<template>
  <span>
    <div v-if="openPopperID != cellData.drawID" @click="openPopper(cellData.drawID)">
      <slot></slot>
    </div>

    <vue-popper
      v-if="openPopperID == cellData.drawID"
      :ref="'popper'+cellData.drawID"
      trigger="click"
      :options="popperOptions"
      :boundaries-selector="'#game-'+gameId"
      :force-show="true"
      @documentClick="closePopper(cellData.drawID)"
      @hide="popperHide(cellData.drawID)"
    >
      <div class="popper history-popper">
        <div class="betlot-popper-header">
          <Row type="flex" justify="space-between">
            <Col>
              <Row type="flex">
                <b class="betlot-title">{{ gameTitle }}</b>
              </Row>
              <Row>
                <div
                  class="betlot-draw-no"
                >{{ $t('general.draw_no') }} {{ gameCode }}{{ cellData.drawID }}</div>
              </Row>
            </Col>
            <Col>
              <Row class="betlot-header-close" type="flex" justify="center" align="middle">
                <Icon type="md-close" size="24" @click="closePopper(cellData.drawID)" />
              </Row>
            </Col>
          </Row>
        </div>
        <Row class="bet-history-summary" type="flex">
          <Col class="bet-history-summary-dices">
            <Row
              class="bet-history-summary-dices-container"
              type="flex"
              justify="center"
              align="middle"
            >
              <Col>
                <Row type="flex" :gutter="12">
                  <Col :span="8">
                    <img
                      :src="require(`../../../assets/images/tai-xiu/assets/dice-${cellData.n1}-active.png`)"
                      width="100%"
                      alt
                    />
                  </Col>
                  <Col :span="8">
                    <img
                      :src="require(`../../../assets/images/tai-xiu/assets/dice-${cellData.n2}-active.png`)"
                      width="100%"
                      alt
                    />
                  </Col>
                  <Col :span="8">
                    <img
                      :src="require(`../../../assets/images/tai-xiu/assets/dice-${cellData.n3}-active.png`)"
                      width="100%"
                      alt
                    />
                  </Col>
                </Row>
                <Row
                  class="bet-history-summary-result-time"
                  type="flex"
                  justify="center"
                >{{cellData.resultTime}}</Row>
              </Col>
            </Row>
          </Col>
          <Col class="bet-history-summary-figures">
            <Row class="bet-history-summary-figures-card" type="flex" justify="center">
              <Col>
                <p class="bet-history-summary-sum-title">{{$t('general.sum')}}</p>
                <p>{{cellData.sum}}</p>
              </Col>
            </Row>
            <Row class="bet-history-summary-figures-card" type="flex" justify="center">{{bigSmall}}</Row>
            <Row class="bet-history-summary-figures-card" type="flex" justify="center">{{oddEven}}</Row>
          </Col>
        </Row>
      </div>

      <div slot="reference" @click="closePopper(cellData.drawID)">
        <slot></slot>
      </div>
    </vue-popper>
  </span>
</template>

<script>
import VuePopper from "vue-popperjs";
import { Row, Col, Icon } from "iview";
import "vue-popperjs/dist/vue-popper.css";
import { titleCase, snakeCase } from "change-case";

export default {
  props: ["game", "cellData", "gameCode", "popperId", "gameId", "tableName"],
  components: {
    VuePopper,
    Row,
    Col,
    Icon
  },
  computed: {
    gameTitle() {
      return titleCase(this.tableName);
    },
    gameSnakeCase() {
      return snakeCase(this.game);
    },
    bigSmall() {
      let gameType =
        this.cellData.bs === "0" ? this.cellData.triple : this.cellData.bs;

      return this.$t(`${this.gameSnakeCase}.o${gameType}`);
    },
    oddEven() {
      let gameType = this.cellData.oe;

      return this.$t(`${this.gameSnakeCase}.o${gameType}`);
    }
  },
  data() {
    return {
      popperOptions: {
        placement: "bottom",
        hide: true,
        modifiers: {
          flip: { behavior: ["bottom", "top"] },
          preventOverflow: { priority: ["left", "right"] }
        },
        removeOnDestroy: true
      },
      openPopperID: ""
    };
  },
  methods: {
    openPopper: function openPopper(a) {
      let vm = this;
      setTimeout(function() {
        vm.openPopperID = a;
      }, 30);
    },
    closePopper: function closePopper(a) {
      this.$refs["popper" + a].doClose();
    },
    popperHide: function popperHide(a) {
      this.$refs["popper" + a].doDestroy(),
        this.openPopperID === a && (this.openPopperID = "");
    }
  }
};
</script>

<style lang="scss">
.popper {
  cursor: default;
}

.history-popper-header-close{
  cursor: pointer;
}

.popper.betlot-popper {
  z-index: 99999;
}

.bet-history-summary.ivu-row-flex {
  margin: 10px;
  color: white;
  text-align: center;
}

.bet-history-summary-dices.ivu-col {
  flex: 1;
}

.bet-history-summary-figures.ivu-col {
  width: 72px;
}

.bet-history-summary-sum-title {
  color: white;
  font-size: 12px;
}

.bet-history-summary-figures-card {
  width: 100%;
  border-radius: 8px;
  padding: 6px;
  margin: 4px 0;
  background-color: #342f2f;
  font-weight: bold;
}

.bet-history-summary-dices-container {
  height: 100%;
  padding: 0 12px;
}

.bet-history-summary-result-time {
  font-size: 12px;
  color: white;
}

.betlot-header-close {
  height: 100%;
}

.popper[x-placement^="top"] .popper__arrow {
  border-width: 5px 5px 0 5px;
  border-color: #3e3838 transparent transparent transparent;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
</style>
